// extracted by mini-css-extract-plugin
export default {"payment-form":"CheckoutPage_payment-form__poPf1"};